<template>
  <div class="tag-list">
    <el-tag
      v-for="(tag, i) in tagList"
      :key="tag"
      type="info"
      disable-transitions
      closable
      @close="updateTag(i)"
    >
      {{ tag }}
    </el-tag>
  </div>
</template>

<script>
export default {
  name: 'TagList',
  props: {
    value: {
      type: [Array, String],
      default: () => []
    }
  },
  computed: {
    isString () {
      return typeof this.value === 'string' && this.value
    },
    tagList () {
      if (this.isString) {
        return this.value.split(',')
      }
      return this.value
    }
  },
  methods: {
    updateTag (i) {
      const list = [...this.tagList]
      list.splice(i, 1)
      let value = list
      if (this.isString) {
        value = list.join(',')
      }
      this.$emit('remove', value)
    }
  }
}
</script>

<style lang="stylus" scoped>
.el-tag {
  text-shadow: none
  margin-top: 8px

  &:not(:last-child) {
    margin-right: 8px
  }
}
</style>
